import {UIStoreState} from '../../../shared/scripts/store/UIStoreState.ts'
import {UIDStoreBodyController} from './UIDStoreBodyController.ts'
import {UIWStoreController} from './UIWStoreController.ts'
import {ClientUserState} from '../../../shared/scripts/ClientUserState.ts'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables.ts'

export class UIDStoreController extends UIWStoreController {
    coinsSection: HTMLElement
    coinsLink: HTMLElement
    avatarsSection: HTMLElement
    avatarsLink: HTMLElement

    protected override init(): void {
        this.storeState = new UIStoreState(this)
        this.bodyController = new UIDStoreBodyController(this.storeState)

        this.coinsSection = document.getElementById('coins') as HTMLElement
        this.coinsLink = document.getElementById('store_coins_link') as HTMLElement
        this.avatarsSection = document.getElementById('avatars') as HTMLElement
        this.avatarsLink = document.getElementById('store_avatars_link') as HTMLElement

        ClientUserState.registerChangeListener((userState) => {
            if(userState == undefined) return
            const hideCoins = hideCoinsSection(userState.forceSubscription)
            this.coinsSection.hidden = hideCoins
            this.coinsLink.hidden = hideCoins
        })
    }
}

function hideCoinsSection(forceSubscription: boolean): boolean {
    if(!UIUtilsEjsVariables.canPurchaseCoinsOnDiscord && forceSubscription) return true
    return false
}
